// eslint-disable-next-line no-restricted-imports
import { useForm, UseFormReturn, UseFormProps } from "react-hook-form";

export function useAppForm<
  Fields extends Record<string, any>,
  Context extends Record<string, any> = Record<string, any>,
>(config: UseFormProps<Fields, Context> = {}): UseFormReturn<Fields> {
  return useForm({ mode: "onChange", ...config });
}
